import { Chip, Menu, MenuItem, Typography } from "@mui/material"
import { useState } from "react"
import { Table } from "@tanstack/react-table"
import { Stack } from "src/shared/components"

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked"
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined"

const ColumnVisiblityAction = ({ table }: { table: Table<any> }) => {
  const [columnMenuanchorEl, setColumnMenuAnchorEl] = useState<any>()
  return (
    <>
      <Chip
        onClick={(e) => setColumnMenuAnchorEl(e.currentTarget)}
        size="small"
        sx={{ px: 0.5 }}
        color="primary"
        clickable
        variant="outlined"
        icon={
          <SettingsOutlinedIcon
            sx={{
              fontsize: (theme) => theme.typography.subtitle2.fontSize ?? "0.65rem"
            }}
          />
        }
        label="Columns"
      />

      {/* </ButtonBase> */}
      <Menu
        sx={{ "& .MuiPaper-root": { width: "fit-content" } }}
        anchorEl={columnMenuanchorEl}
        open={!!columnMenuanchorEl}
        onClose={() => setColumnMenuAnchorEl(undefined)}
      >
        <MenuItem disableRipple key={"first-0"} onClick={table.getToggleAllColumnsVisibilityHandler()}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {table.getIsAllColumnsVisible() ? (
              <RadioButtonCheckedIcon sx={{ fontSize: (theme) => theme.typography.body2.fontSize }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ fontSize: (theme) => theme.typography.body2.fontSize }} />
            )}
            <Typography variant="body2" fontWeight={600}>
              Toggle All
            </Typography>
          </Stack>
        </MenuItem>
        {table.getAllLeafColumns().map((col) => (
          <MenuItem key={col.id as string} disabled={!col.getCanHide()} onClick={col.getToggleVisibilityHandler()}>
            <Stack direction="row" alignItems="center" spacing={1}>
              {col.getIsVisible() ? (
                <RadioButtonCheckedIcon sx={{ fontSize: (theme) => theme.typography.body2.fontSize }} />
              ) : (
                <RadioButtonUncheckedIcon sx={{ fontSize: (theme) => theme.typography.body2.fontSize }} />
              )}
              <Typography variant="body2" fontWeight={600}>
                {(typeof col.columnDef?.header === "string" ? col.columnDef?.header : col.columnDef?.id) as string}
              </Typography>
            </Stack>
            {/* <FormControlLabel
              disabled={!col.getCanHide()}
              control={
                <input
                  {...{
                    type: "checkbox",

                    checked: col.getIsVisible(),
                    onChange: col.getToggleVisibilityHandler()
                  }}
                />
              }
              label={col.columnDef?.header as string}
            /> */}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default ColumnVisiblityAction
